import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import "./AmpFormError.css";


interface AmpFormErrorProps {
    errorMessage: string | null;
    error: boolean
}

export default function AmpFormError(props: AmpFormErrorProps):JSX.Element {

    if (props.error) {
        return (
            <div className="error-field">
                <FontAwesomeIcon icon={faTimesCircle} />
                <div className="text">{props.errorMessage}</div>
            </div>
        )
    } else {
        return (
            <div></div>
        )
    }

}